import React, { PureComponent } from "react";


export default class Image extends PureComponent {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.state = {
      ready: false
    }
  }

  componentWillMount() {
    this._mounted = true;
    const img = new window.Image();
    img.src = this.props.src;
    img.onload = () => {
      this._mounted && this.setState({ ready: true })
    };
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  render() {
    const { src, thumb } = this.props;
    const { ready } = this.state;
    const image = ready ? src : thumb;
    const blur = ready ? 0 : 10;
    const style = {
      filter: `blur(${blur}px)`,
      transition: 'filter 0.3s ease-in-out',
    };

    return (
      <img
        src={image}
        style={style}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/Image/Image.jsx